import { render } from "./TvBoard.vue?vue&type=template&id=9bc4f60e"
import script from "./TvBoard.vue?vue&type=script&lang=js"
export * from "./TvBoard.vue?vue&type=script&lang=js"
script.render = render

export default script